module.exports = __webpack_public_path__ + "img/rw_arrange_letters2.8a5fea19.png";